<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 18.828 18.828">
    <!-- eslint-disable-next-line max-len -->
    <path
      id="image"
      d="M4.99,9H9M9,9V5.028M4,4,9,9M19,9H15m0,0V5.028M20,4,18.975,5.025l-.746.746L15,9M4.99,15H9m0,0v4.007M4,20l5-5m11,5-5-5m4,0H15m0,4.007V15"
      transform="translate(-2.586 -2.586)"
      fill="none"
      stroke="#fff"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
  </svg>
</template>
